/* eslint no-template-curly-in-string: 0 */

import { defineMessages } from 'react-intl'
import {
  IconCheckCircle,
  IconTimesCircle,
  IconInfoCircle
} from 'src/Components/Icon'

export const refiTodayKey = v => `fix${v}Yr`

export const REFI_BULLETS = defineMessages({
  // {years}, {abs_shortterm}, {pmi}
  fix_good: {
    id: 'Refinance.short.bullets.fix_good',
    defaultMessage: 'Long term savings',
    icon: IconCheckCircle
  },
  fix_bad: {
    id: 'Refinance.short.bullets.fix_bad',
    defaultMessage: 'Long term loss',
    icon: IconTimesCircle
  },
  arm_good: {
    id: 'Refinance.short.bullets.arm_good',
    defaultMessage: 'Risky after {years} years',
    icon: IconInfoCircle,
    color: 'green'
  },
  arm_bad: {
    id: 'Refinance.short.bullets.arm_bad',
    defaultMessage: 'Risky after {years} years',
    icon: IconInfoCircle,
    color: 'orange'
  },
  short_good: {
    id: 'Refinance.short.bullets.short_good',
    defaultMessage: 'Payment might go down by {abs_shortterm}/mo',
    icon: IconCheckCircle
  },
  short_same: {
    id: 'Refinance.short.bullets.short_same',
    defaultMessage: 'Payment may not change',
    icon: IconInfoCircle
  },
  short_bad: {
    id: 'Refinance.short.bullets.short_bad',
    defaultMessage: 'Payment might go up by {abs_shortterm}/mo',
    icon: IconTimesCircle
  },
  pmi: {
    id: 'Refinance.short.bullets.pmi',
    defaultMessage: 'Could remove {pmi}/mo in PMI',
    icon: IconCheckCircle
  }
})

export const REFI_DETAILS_HEADLINE_ARM = defineMessages({
  // {label}, {years}
  good: {
    id: 'Refinance.details.headline.arm.good',
    defaultMessage:
      'A {label} could save you money over time and each month, but keep an eye on the adjustable rate!'
  },
  long: {
    id: 'Refinance.details.headline.arm.long',
    defaultMessage:
      'A {label} could help you save some money over {years} years, but keep an eye on the adjustable rate!'
  },
  short: {
    id: 'Refinance.details.headline.arm.short',
    defaultMessage:
      'A {label} could lower your monthly payment, but keep an eye on the adjustable rate!'
  },
  bad: {
    id: 'Refinance.details.headline.arm.bad',
    defaultMessage:
      'A {label} loan might lose you money -- each month and long-term.'
  }
})

export const REFI_DETAILS_HEADLINE_FIX = defineMessages({
  // {label}
  good: {
    id: 'Refinance.details.headline.fix.good',
    defaultMessage:
      'A {label} loan could save you money over time and each month!'
  },
  long: {
    id: 'Refinance.details.headline.fix.long',
    defaultMessage:
      'A {label} loan could provide long-term savings, but likely with a higher monthly payment.'
  },
  short: {
    id: 'Refinance.details.headline.fix.short',
    defaultMessage:
      'A {label} loan could decrease your monthly payment, but likely at a long-term loss.'
  },
  bad: {
    id: 'Refinance.details.headline.fix.bad',
    defaultMessage:
      'A {label} loan might lose you money -- each month and long-term.'
  }
})

export const REFI_DETAILS_BULLETS = defineMessages({
  // {years}, {now_years}, {abs_shortterm}, {pmi}, {potential30Year}, {yearsInHome}
  fix: {
    id: 'Refinance.details.bullets.fix',
    defaultMessage:
      'Since the rate is fixed, your monthly principal and interest payment stay fixed',
    icon: IconCheckCircle
  },
  arm: {
    id: 'Refinance.details.bullets.arm',
    defaultMessage:
      'If you plan on keeping your home for {years}+ years, this loan could be risky because rates could increase by {now_years}',
    icon: IconInfoCircle
  },
  good: {
    id: 'Refinance.details.bullets.good',
    defaultMessage:
      "Your payment could decrease by {abs_shortterm}/mo and you'd likely see long-term savings",
    icon: IconCheckCircle
  },
  long: {
    id: 'Refinance.details.bullets.long',
    defaultMessage:
      "Your payment could increase by {abs_shortterm}/mo, but you'd likely see long-term savings",
    icon: IconTimesCircle
  },
  short: {
    id: 'Refinance.details.bullets.short',
    defaultMessage:
      "Your payment could decrease by {abs_shortterm}/mo, but you'd likely pay more interest over the long-term",
    icon: IconCheckCircle
  },
  bad: {
    id: 'Refinance.details.bullets.bad',
    defaultMessage:
      "Your payment could increase by {abs_shortterm}/mo and you'd likely lose money over the long-term, too",
    icon: IconTimesCircle
  },
  pmi: {
    id: 'Refinance.details.bullets.pmi',
    defaultMessage: 'Remove your monthly PMI payment of {pmi}',
    icon: IconCheckCircle
  },
  potential_good: {
    id: 'Refinance.details.bullets.potential_good',
    defaultMessage:
      'Your estimated savings over 30-years could be {potential30Year} if rates stayed relatively the same as today',
    icon: IconCheckCircle
  },
  potential_bad: {
    id: 'Refinance.details.bullets.potential_bad',
    defaultMessage:
      'Your estimated loss over 30-years could be {potential30Year} if rates stayed relatively the same as today',
    icon: IconTimesCircle
  }
})

export const REFI_CHART_MESSAGES = defineMessages({
  // {year}
  tooltip: {
    id: 'Refinance.chart.tootlip',
    defaultMessage: 'Year {year}'
  },
  unknown: {
    id: 'Refinance.chart.unknown',
    defaultMessage: 'Unknown'
  }
})

export const MONTHS_IN_YEAR = 12
export const MONTHS_IN_30_TERM_LOAN = 360
export const NO_INTEREST_PAID = 0
export const REFI_DETAILS_VIEW_EVENT = 'viewedRefiDetails'
export const REFI_DETAILS_EVENT_SUBMITTED_KEY = 'refiDetailsEventSubmitted'
